<script lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
export default {
  mixins: [mixin],
  methods: {
    $renderPrice() {
      return this.mx_plans.map((plan) => {
        return (
          <div class="opc-cart-item">
            {this.mx_title(this.$t('billing.planform.title.ldk_cmr'), this.mx_price(plan))}
            {this.mx_cycle(plan.billing_cycle)}
            {this.mx_license(plan.cartCapacity, plan.cartCapacityUnit)}
            {this.mx_edit(plan)}
            {this.mx_remove(plan)}
          </div>
        );
      });
    },
    $renderAgreement() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>
